import { render, staticRenderFns } from "./ExtMenu.vue?vue&type=template&id=1f2ea396&scoped=true&"
import script from "./ExtMenu.vue?vue&type=script&lang=js&"
export * from "./ExtMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExtMenu.vue?vue&type=style&index=0&id=1f2ea396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2ea396",
  null
  
)

export default component.exports